import { TopToolbar } from 'react-admin'
const ClubShowNoTabsActions = ({ basePath, data }) => {
	return (
		<TopToolbar>
		</TopToolbar>
	)
}
export default ClubShowNoTabsActions